import { render, staticRenderFns } from "./friendHandleMessageList.vue?vue&type=template&id=204e6fa8&scoped=true&"
import script from "./friendHandleMessageList.vue?vue&type=script&lang=js&"
export * from "./friendHandleMessageList.vue?vue&type=script&lang=js&"
import style0 from "./friendHandleMessageList.vue?vue&type=style&index=0&id=204e6fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e6fa8",
  null
  
)

export default component.exports